module.exports = "<p>\r\n  {{ 'user-not-logged' | translate }}\r\n</p>\r\n"